import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const FinancialSuccess = lazy(() => import('../pages/financial-success/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Calculator = lazy(() => import('../pages/calculator/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/financial-success', element: <FinancialSuccess /> },
  { path: '/about', element: <About /> },
  { path: '/contact', element: <Contact /> },
  { path: '/calculator', element: <Calculator /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
